<template>
  <div
    class="page_container addEditBrandIncreasePage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >辅助功能&内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/articleIndex/articleList' }"
          >买手图文管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>买手图文设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>买手图文设置</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>图文审核状态：</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.checkstate"
                style="justify-content: space-evenly"
              >
                <el-radio label="待审核">待审核</el-radio>
                <el-radio label="已审核">已审核 </el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>图文显示状态：</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.at_state"
                style="justify-content: space-evenly"
              >
                <el-radio label="显示">显示</el-radio>
                <el-radio label="隐藏">隐藏 </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  uploadImage,
  encryptstringview,
} from "../../api/api";
import { getArticleDetail, editArticle } from "../../api/article";
import { mapState } from "vuex";
export default {
  name: "articleEdit",
  data() {
    return {
      qyid: 0,
      id: "",

      loading: false,
      formData: {
        id: "",
        slid: '',
        checkstate: "",
        at_state: "",
      },
      creenIndex: "",
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        if (id) {
          this.formData.id = id;
          this.init(id);
        }
      } else {
        this.$router.back();
      }
    },

    init(id) {
      this.loading = true;
      getArticleDetail({ id }).then((res) => {
        this.formData.slid = res.slid;
        this.formData.checkstate = res.checkstate;
        this.formData.at_state = res.at_state;
        this.loading = false;
      });
    },

    handleReturn() {
      history.back();
    },

    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          this.formData.logo = res.url;
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    query() {
      let { formData } = this;
      if (formData.checkstate == "") {
        this.$message.warning("请选择图文审核状态");
        return;
      }
      if (formData.at_state == "") {
        this.$message.warning("请选择图文显示状态");
        return;
      }
      editArticle(formData).then((res) => {
        if (res.result) {
          this.$message.success(res.message);
          // setTimeout(() => {
          //   history.back();
          // }, 1500);
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 1800);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.addEditBrandIncreasePage {
}
</style>